<template></template>

<script>
import { createNamespacedHelpers } from "vuex";
import store from "@/lib/store";
import { customerBusyNotification, repBusyNotification } from "./notifications";

const { mapState } = createNamespacedHelpers("conference");

export default {
  props: ["channel"],
  data() {
    return {
      user: store.get("user"),
    };
  },
  computed: mapState(["activity"]),
  created() {
    this.channel.bind("connection.busy", ({ participant }) => {
      if (participant.userId === this.user.id) {
        repBusyNotification({
          phoneNumber: this.activity.from.internationalPhoneNumber,
        }).show();
      } else if (!participant.isGhost) {
        // Customer
        customerBusyNotification().show();
      }
    });
  },
};
</script>



// WEBPACK FOOTER //
// connection-busy.vue?02ca5c94